import uPlot from "uplot"
import _ from "lodash"
import moment from "moment";

let chartSyncs = {};

let Hooks = {}

Hooks.Chart = {
  mounted() {
    this.chart = null;
    this.timer = null;
    this.lastTime = null;
    this.chartData = null;
    this.size = this.calcSize();
    this.requestData = _.throttle(this.requestDataImmediate, 1000)

    const data = this.el.dataset;

    let opts = _.merge(
      this.size,
      (window._chartOptions && window._chartOptions[this.el.id]) || {},
      JSON.parse(data.options || "{}")
    )

    const syncName = data.sync;
    let sync = null;
    if (syncName) {
      sync = chartSyncs[syncName];
      if (sync === undefined) {
        sync = uPlot.sync(syncName);
        chartSyncs[syncName] = sync;
      }

      opts.cursor ||= {}
      opts.cursor.sync ||= {}
      opts.cursor.sync.key = sync.key
    }

    let chartData = JSON.parse(data.data || "{}")
    this.chart = uPlot(opts, chartData, this.el);

    window.addEventListener("resize", () => this.updated());
  },

  destroyed() {
    if (this.timer) clearInterval(this.timer);
  },

  updated() {
    if (this.chart) {
      let newSize = this.calcSize();
      if (newSize.width != this.size.width || newSize != this.size.height) {
        this.chart.setSize(newSize);
        this.size = newSize;
        if (newSize.width != this.size.width) this.requestData();
      }
    }
  },

  calcSize() {
    let titleOuter = this.el.getElementsByTagName("h4")[0];
    let title = this.el.getElementsByClassName("u-title")[0];
    let legend = this.el.getElementsByClassName("u-legend")[0];
    let height = (titleOuter ? titleOuter.offsetHeight : 0.0) + (title ? title.offsetHeight : 0.0);
    height += legend ? legend.offsetHeight : 70.0;
    return {
      width: this.el.clientWidth,
      height: this.el.clientHeight - height
    }
  },

  requestDataImmediate() {
    const size = this.calcSize();
    this.pushEventTo(this.el, "request-data", {width: size.width, lastTime: this.lastTime})
  },

  requestData() {
    // Will be replaced on mount
    this.requestDataImmediate();
  },

  restartTimer() {
    if (this.timer) clearInterval(this.timer);
    this.timer = setInterval(() => this.requestData(), 60000);
  },

  // Based on https://github.com/leeoniya/uPlot/issues/814
  ungapper(u, sidx, idx0, idx1, nullGaps) {
    let xData = u.data[0];
    let yData = u.data[sidx];

    // min px distance for gap retention
    const minutes = 10;
    const minGapPx =
      Math.round(u.valToPos(xData[0] + minutes*60, 'x', true)) -
      Math.round(u.valToPos(xData[0], 'x', true));

    return nullGaps.filter(([fromPx, toPx]) => toPx - fromPx > minGapPx);
  },
}

export {Hooks}
